import { render, staticRenderFns } from "./SubjectModal.vue?vue&type=template&id=2234c2cd&"
import script from "./SubjectModal.vue?vue&type=script&lang=js&"
export * from "./SubjectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports